import { ACCOUNT_ID_CONFIG } from '../constants/accountIdConfigTypes';

const initialState = {
  data: {
    account_id_config: {},
  },
  isLoading: false,
};

const accountIdConfig = (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT_ID_CONFIG:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    default:
      break;
  }

  return state;
};

export default accountIdConfig;
